<template>
  <div>
    <a-card :head-style="{ background: '#f3f3f3' }">
      <template #title>搜索源配置</template>
      <div>
        <a-form :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules">
          <a-form-item label="搜索供应">
            <a-radio-group v-model:value="formState.operation">
              <a-radio value="1">同城</a-radio>
              <a-radio value="3">51book</a-radio>
              <a-radio value="8">东美</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item :wrapper-col="{ offset: 8 }">
            <a-button @click="submit">提交</a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-card>

      <a-card :head-style="{ background: '#f3f3f3' }">
          <template #title>现金票供应配置</template>
          <div>
              <a-form :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules">
                  <a-form-item label="现金票供应">
                      <a-radio-group v-model:value="cashformState.operation">
                          <a-radio value="3">51book</a-radio>
                          <a-radio value="7">万顺</a-radio>
                      </a-radio-group>
                  </a-form-item>
                  <a-form-item :wrapper-col="{ offset: 8 }">
                      <a-button @click="cashSubmit">提交</a-button>
                  </a-form-item>
              </a-form>
          </div>
      </a-card>


    <a-card :head-style="{ background: '#f3f3f3' }">
      <template #title>电子票票供应配置</template>
      <div>
        <a-form :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules">
          <a-form-item label="电子票供应">
            <a-radio-group v-model:value="electronicFormState.operation">
              <a-radio value="11">51book</a-radio>
              <a-radio value="10">万顺</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item :wrapper-col="{ offset: 8 }">
            <a-button @click="electronicSubmit">提交</a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-card>

  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import supply from "@/axios/supply";
import {message, notification} from "ant-design-vue";
import {useRouter} from "vue-router";
export default {
  name: "configManage",
  setup(){
    const router = useRouter();
    let supplyData = {
      1:"同城",
      3:"51book",
      8:"东美",
      7:"万顺",
      10:"万顺(电子票)",
      11:"51book(电子票)"
    }
    let formState = reactive({
      configCode: "search_supplier_config",
      operation: ""
    });
    const getConfig = () => {
      supply.getBaseConfig({configCode:"search_supplier_config"}).then((res) => {
        formState.operation = res.operation
        message.success({
          content: "当前查询数据供应商为："+supplyData[formState.operation]
        })
      })
    };
    getConfig()
    let submit = () => {
      supply.setBaseConfig(formState).then((respond) => {
        message.success({
          content: "修改成功"
        })
        router.push({
          name: "configManage",
        });
        message.success({
          content: "当前查询数据供应商为："+supplyData[formState.operation]
        })
      });
    };
    // 开始现金票供应配置
      let cashformState = reactive({
          configCode: "cash_ticket_supplier_config",
          operation: ""
      });


      const getCashConfig = () => {
          supply.getBaseConfig({configCode:"cash_ticket_supplier_config"}).then((res) => {
              cashformState.operation = res.operation
              message.success({
                  content: "当前现金票供应商为："+supplyData[cashformState.operation]
              })
          })
      };
      getCashConfig()
      let cashSubmit = () => {
          supply.setBaseConfig(cashformState).then((respond) => {
              message.success({
                  content: "修改成功"
              })
              router.push({
                  name: "configManage",
              });
              message.success({
                  content: "当前现金票供应商为："+supplyData[cashformState.operation]
              })
          });
      };


    // 开始电子票供应配置
    let electronicFormState = reactive({
      configCode: "electronic_ticket_supplier_config",
      operation: ""
    });
    const getEleConfig = () => {
      supply.getBaseConfig({configCode:"electronic_ticket_supplier_config"}).then((res) => {
        electronicFormState.operation = res.operation
        message.success({
          content: "当前电子票供应商为："+supplyData[electronicFormState.operation]
        })
      })
    };
    getEleConfig()
    let electronicSubmit = () => {
      supply.setBaseConfig(electronicFormState).then((respond) => {
        message.success({
          content: "修改成功"
        })
        router.push({
          name: "configManage",
        });
        message.success({
          content: "当前电子票供应商为："+supplyData[electronicFormState.operation]
        })
      });
    };

    const rules = {
      account: [
        {
          required: true,
          message: "Please input Activity name",
          trigger: "blur",
        },
      ],
    };

    return {
      rules,
      formState,
      submit,
      labelCol: {
        span: 8,
      },
      wrapperCol: {
        span: 6,
      },
      electronicSubmit,
      electronicFormState,
        cashformState,
        cashSubmit,
    }
  }

}
</script>

<style lang='scss' scoped>
/deep/ .ant-radio-checked .ant-radio-inner {
  border-color: #1bba79 !important;
}
</style>